export default "__VITE_ASSET__XnLP8BWT__"